import { useQuery } from 'react-query';
import { API } from 'aws-amplify';
import QUERY_CACHE_KEY from '../../constants/QueryCacheKey';
import { getCoach } from '../../graphql/queries';

function useCoachQuery(id, options = {}) {
  return useQuery(
    QUERY_CACHE_KEY.coach(id),
    async () => {
      const res = await API.graphql({ query: getCoach, variables: { id } });
      return res.data.getCoach;
    },
    {
      enabled: !!id,
      ...options,
    }
  );
}

export default useCoachQuery;
